"use client";

import { usePathname } from "next/navigation";

import { isEpaperReaderRoute } from "@/utils/epaper";
import useEpaperStore from "@/hooks/useEpaperStore";

export default function EpaperFooter() {
  const pathName = usePathname();
  const reader = isEpaperReaderRoute(pathName);
  const { cropActive, editionModalOpen } = useEpaperStore();

  const hideOnMobileOverlay = reader && (cropActive || editionModalOpen);

  return (
    <div
      className={
        "bg-[#131311] " +
        (hideOnMobileOverlay ? "max-sm:hidden " : "") +
        (reader
          ? "mb-0 max-sm:z-[10] max-sm:pb-[env(safe-area-inset-bottom,0px)] max-sm:shadow-[0_-4px_14px_rgba(0,0,0,0.35)] sm:relative sm:shadow-none "
          : "mb-0 ")
      }
    >
      <div className="w-full px-4 flex flex-col items-center justify-between gap-2 py-3 md:flex-row">
        <span className="text-white text-[13px] order-2 md:order-1">
          Copyrights © {new Date().getFullYear()}. All Right Reserved.
        </span>
        <div className="flex items-center order-1 gap-1 md:order-2">
          <span className="text-white text-[13px]">Powered By</span>
          <a
            href="https://faircodetech.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit Faircode infotech"
          >
            <img
              src="/images/fc-logo.webp"
              alt="Faircode infotech"
              className="w-[80px] h-full"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
